import request from '@/axios';
import { SearchHistoryApiFromBackType } from './types';

export const getSearchHistoryApi = (): Promise<
  IResponse<SearchHistoryApiFromBackType[]>
> => {
  return request.get({ url: process.env.VUE_APP_SEARCH_HISTORY });
};
